module.exports = __webpack_public_path__ + "static/media/33.fd5e715f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/33.jpg
// module id = 293
// module chunks = 0